import { URLS } from '@/data/config';
import { createActiveWalletJurisdictionHeaders } from '@/hooks/use-active-wallet';
import { useMutation } from '@tanstack/react-query';

export const useFundFantasyFromSocialWallet = () => {
    return useMutation({
        mutationFn: async (amount: number) => {
            const body = new URLSearchParams();
            body.append('amount', amount.toString());

            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...createActiveWalletJurisdictionHeaders(),
            };

            const response = await fetch(`${URLS.CHAMELON_API_URL}/auth/wallet/redeem-to-fantasy`, {
                method: 'POST',
                headers,
                body: body.toString(),
            });

            const data = await response.json().catch(() => undefined);

            if (!response.ok) {
                throw data;
            }

            return data;
        },
    });
};
